import { render, staticRenderFns } from "./SetTermination.vue?vue&type=template&id=23ab161b&"
import script from "./SetTermination.vue?vue&type=script&lang=js&"
export * from "./SetTermination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports